import React, { Component } from 'react';
import * as $ from 'jquery';
// import moment from 'moment-timezone';
// import spinner from '../../images/loading-spinner.gif';
import { translate } from 'react-i18next';
// import brandLogo from '../../images/brand-logo-inverse-light.png';


class CoworkSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: ''
        }
    }

    componentDidMount() {
        this.setState({ error: 'si' });
        $('#date').datepicker({
            onSelect: (d, i) => {
                if (d !== i.lastVal) {
                    this.props.handleDateChange(d);
                }
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const city = this.props.city;
        if (city === '0' || city === '') {
            const errorMessage = this.props.t('venta_linea.index.cowork.error_select')
            this.setState({ errorMessage });
            return;
        }
        this.setState({ errorMessage: '' });
        this.props.handleRoomSearch(e);
    }

    render() {
        const { t } = this.props;
        const { errorMessage } = this.state;
        // const center = this.props.center;
        // var today = new Date();
        // const min_date = moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
        // const new_date = moment(this.props.date, 'MM/DD/YYYY').format('YYYY-MM-DD')
        // var start = this.props.start_day ? this.props.start_day : this.props.date;
        // const start_data = moment(start, 'MM/DD/YYYY').format('MM-DD-YYYY')
        // var end = this.props.finsh_day ? this.props.finsh_day : this.props.date;
        // var finsh_day = moment(end, 'MM/DD/YYYY').format('MM-DD-YYYY')
        return (
            <div className="jumbotron panel-search-resvations">
                <div className="row">
                    <div className="col-md-12">
                        <form method="post" onSubmit={this.handleSubmit}>
                            <fieldset>
                                <div className="form-group">
                                    <label htmlFor="center">
                                        {t('guest.benefits.city')}
                                    </label>
                                    <select
                                        className="form-control"
                                        id="city-select"
                                        onChange={this.props.handleCityChange}
                                        value={this.props.city}>
                                        {this.props.cuidad.map((city, index) =>
                                            index <= 0 ? (
                                                <option key={index} className="opcion-select" value={index}>{t('guest.survey.holder_city')}</option>
                                            ) : (
                                                <option key={index} className="opcion-select" value={city.id}>{city.name}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                <div className="form-group">
                                    <button
                                        className="btn btn-primary btn-full-width"
                                        type="submit">
                                        {t('dashboard.reservations.btn_search')}
                                    </button>
                                    <div className={this.props.isSearching ? "demo-container" : "hidden"}>
                                        <div className="progress-bar">
                                            <div className="progress-bar-value"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className={this.props.error ? "" : "hidden"}>
                                    <div className="form-group">
                                        <div className="alert alert-warning">
                                            {this.props.error}
                                            <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}


export default translate('common')(CoworkSearch);


// WEBPACK FOOTER //
// ./src/store/Cowork/CoworkSearch.js